import React from 'react';

import PrivateRoute from 'layouts/PrivateRoute';
import PublicRoute from 'layouts/PublicRoute';
import AccountsPage from 'pages/Account/AccountsPage';
import ConnectionFailurePage from 'pages/ConnectionFailure/ConnectionFailurePage';
import ForgotCredentialsPage from 'pages/ForgotCredentials/ForgotCredentialsPage';
import LandingPage from 'pages/Landing/LandingPage';
import AuthenticationPage from 'pages/Login/AuthenticationPage';
import PageNotFound from 'pages/NotFound/NotFoundPage';
import PlanPage from 'pages/Plan/PlanPage';
import ProfileAddressPage from 'pages/Profile/AddressPage/ProfileAddressPage';
import ProfilePasswordPage from 'pages/Profile/PasswordPage/ProfilePasswordPage';
import ProfilePhonePage from 'pages/Profile/PhonePage/ProfilePhonePage';
import PreferredLanguagePage from 'pages/Profile/PreferredLanguagePage';
import ProfileEmailPage from 'pages/Profile/ProfileEmailPage';
import ProfilePage from 'pages/Profile/ProfilePage';
import RegistrationPage from 'pages/Registration/RegistrationPage';
import SessionExpiredPage from 'pages/SessionExpired/SessionExpiredPage';
import StatementsPage from 'pages/Statements/StatementsPage';
import TransactionHistoryPage from 'pages/Transaction/HistoryPage';
import { AppRoutes } from 'routes';

import { getAllRoutesById, LocalizedSwitch } from './i18n';

const Router = () => (
    <LocalizedSwitch>
        <PublicRoute
            allowAuthenticatedUser={false}
            component={LandingPage}
            exact
            path={getAllRoutesById([AppRoutes.landingPage])}
        />
        <PublicRoute
            allowAuthenticatedUser={false}
            component={AuthenticationPage}
            exact
            path={getAllRoutesById([AppRoutes.loginPage, AppRoutes.baseRoute])}
        />
        <PublicRoute
            allowAuthenticatedUser={false}
            component={ForgotCredentialsPage}
            exact
            path={getAllRoutesById([AppRoutes.forgotCredentialsPage])}
        />
        <PublicRoute
            allowAuthenticatedUser={false}
            component={RegistrationPage}
            exact
            path={getAllRoutesById([AppRoutes.registrationPage])}
        />
        <PublicRoute
            allowAuthenticatedUser={false}
            component={SessionExpiredPage}
            exact
            path={getAllRoutesById([AppRoutes.sessionExpiredPage])}
        />
        <PublicRoute component={PageNotFound} path={getAllRoutesById([AppRoutes.pageNotFound])} />
        <PublicRoute component={ConnectionFailurePage} path={getAllRoutesById([AppRoutes.connectionFailurePage])} />
        <PrivateRoute component={AccountsPage} exact path={getAllRoutesById([AppRoutes.accounts])} />
        <PrivateRoute component={StatementsPage} exact path={getAllRoutesById([AppRoutes.eStatements])} />
        <PrivateRoute component={ProfilePage} exact path={getAllRoutesById([AppRoutes.profile])} />
        <PrivateRoute component={ProfileEmailPage} exact path={getAllRoutesById([AppRoutes.profileEmail])} />
        <PrivateRoute component={ProfilePhonePage} exact path={getAllRoutesById([AppRoutes.profilePhone])} />
        <PrivateRoute component={ProfileAddressPage} exact path={getAllRoutesById([AppRoutes.profileAddress])} />
        <PrivateRoute component={PreferredLanguagePage} exact path={getAllRoutesById([AppRoutes.profileLanguage])} />
        <PrivateRoute component={ProfilePasswordPage} exact path={getAllRoutesById([AppRoutes.profilePassword])} />
        <PrivateRoute component={PlanPage} exact path={getAllRoutesById([AppRoutes.planPage])} />
        <PrivateRoute
            component={TransactionHistoryPage}
            exact
            path={getAllRoutesById([AppRoutes.transactionHistoryPage])}
        />
    </LocalizedSwitch>
);

export default Router;
